import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paper, Box, Grid, Chip, CircularProgress, Checkbox , Autocomplete , TextField , MenuItem } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import MyTable from '../../components/Schedule/MyTable';
import { toast } from 'react-toastify';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import ClearIcon from "@mui/icons-material/Clear";
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from 'react-bootstrap';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { DatePicker } from '@mui/x-date-pickers';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import Multiselect from 'multiselect-react-dropdown';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Tooltip } from '@mui/material';
import './passes.css'

const EditPasses = () => {
  let navigate = useNavigate();
  const { user , v3Data } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [employees, setEmployees] = useState([])
  const [selectedEmp , setSelectedEmp] = useState('');
  const [selectPassess , setSelectPasses] = useState('');
  const [overtimeList , setOvertimeList] = useState([]);
  const [addModal , setAddModal] = useState(false);
  const [selectOvertimeList , setSelectOvertimeList] = useState('');
  const [rows , setRows] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [activeTab , setActiveTab] = useState('edit-pass');
  const [selectDate , setSelectDate] = useState(null);
  const [selectModalPass , setSelectModalPass] = useState('');
  const [selectModalOvertime , setSelectModalOvertime] = useState('');
  const [selectModalEmp , setSelectModalEmp] = useState([]);
  const [deleteModal , setDeleteModal] = useState(false);

  const loadEmployees = () => {
    ApiService.get('/employeeToSwap')
      .then(({ data }) => {
        var tempArr = []
        data.map((emp) => {
          var obj = emp
          obj.label = `${emp.EA_Rank} ${emp.fullName}`
          tempArr.push(obj)
        })
        setEmployees(tempArr)
      })
      .catch((e) => {
        setLoading(false);
      })
  }

  const loadDropDowns = () => {
    ApiService.get('/getOverTimeListDDL').then(({ data }) => {
      setOvertimeList(data)
    })
  }

  useEffect(()=>{
    loadEmployees()
    loadDropDowns()
  }, [])

  const passess = [
    {label : 'Free Pass' , value : 'FREE_PASS'},
    {label : 'Monthly Pass' , value : 'MONTHLY_PASS'},
    {label : '3 Shift Pass' , value : '3_SHIFT_PASS'},
  ]

  const columns = [
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      minWidth:140,
    },
    {
      field: 'employee',
      headerName: 'Employee',
      flex: 1,
      minWidth:220,
    },
    {
      field: 'type',
      headerName: 'Type',
      flex: 1,
      minWidth:160,
    },
    {
      field: 'list',
      headerName: 'List',
      flex: 1,
      minWidth:160,
      renderCell: (params) => (
        <span>
          { params?.row?.list || params?.row?.os_list?.Overtime_List}
        </span>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth:160,
      renderCell: (params) => (
        <Chip
          label={params.value}
        />
      ),
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      minWidth:120,
      renderCell: (params) => (
        <>
          <Tooltip title="Delete">
            <IconButton
              color="primary"
              onClick={() => {
                setDeleteModal(true);
                setSelectedEmployee(params?.row);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Close">
            <IconButton
              color="primary"
              onClick={() => handleClose(params?.row)}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const getPassesList = () => {
    setLoading(true)
    ApiService.get(`/manage-osp`, {
      "Shift_Date": fromDate ? moment(fromDate).format('YYYY-MM-DD') : "",
      "Type": selectPassess,
      "Overtime_List" : selectOvertimeList,
      "Emp_Code" : selectedEmp
    })
      .then(({ data }) => {
        setRows(data?.data || [])
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getPassesList()
  }, [fromDate , selectPassess , selectOvertimeList, selectedEmp ])

  const handlePass = () => {
    setLoading(true)
    ApiService.post(`/create-osp`, {
      "Shift_Date": selectDate ? moment(selectDate).format('YYYY-MM-DD') : "",
      "Type": selectModalPass,
      "Overtime_List" : selectModalOvertime,
      "Emp_Codes" : selectModalEmp.map((emp) => emp.Emp_Code)
    })
      .then(( data ) => {
        toast.success(data.message || 'success');
        setLoading(false);
        setAddModal(false);
        setSelectDate(null)
        setSelectModalPass('');
        setSelectModalOvertime('');
        setSelectModalEmp([]);
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e.data.message || 'error')
      });
  }

  const handleDelete = () => {
    setLoading(true)
    ApiService.post(`/delete-osp`, {
      "Shift_Date": selectedEmployee?.date ? moment(selectedEmployee?.date).format('YYYY-MM-DD') : "",
      "Type": selectedEmployee?.type,
      "Overtime_List" : selectedEmployee?.list,
      "Emp_Code" : selectedEmployee?.emp_code
    })
      .then(( data ) => {
        toast.success(data.message || 'success');
        getPassesList()
        setLoading(false);
        setDeleteModal(false);
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e.data.message || 'error')
      });
  }

  const handleClose = (selectedEmployee) => {
    setLoading(true)
    ApiService.post(`/cancel-osp`, {
      "Shift_Date": selectedEmployee?.date ? moment(selectedEmployee?.date).format('YYYY-MM-DD') : "",
      "Type": selectedEmployee?.type,
      "Emp_Code" : selectedEmployee?.emp_code
    })
      .then(( data ) => {
        toast.success(data.message || 'success');
        getPassesList()
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e.data.message || 'error')
      });
  }


  return (
    <>
      <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
        <Row>
          <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
            <div style={{ width: '200px' }} className={activeTab == 'manage-free-pass' ? 'tab-active mx-1' : 'tab-white mx-1'}
              onClick={() => {
                setActiveTab('manage-free-pass')
                navigate('/firehouse/manage-free-passes')
              }}>
              Manage Free Passes
            </div>
          </Col>
          {/* <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
            <div style={{ width: '200px' }} className={activeTab == 'edit-pass' ? 'tab-active mx-1' : 'tab-white mx-1'}
              onClick={() => {
                setActiveTab('edit-pass')
                navigate('/firehouse/edit-passes')
              }}>
              Edit Passes
            </div>
          </Col> */}
        </Row>
        
        <Grid container spacing={2} className='mt-2'>
          <Grid item xs={12} sm={12} md={2.5} className='d-grid'>
            <label className='mb-1'>Shift Date</label>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <ButtonDatePicker
                fullWidth
                label={fromDate ? moment(fromDate).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                value={fromDate}
                onChange={(e) => setFromDate(e)}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12} sm={12} md={2.5} className='d-grid'>
            <label className='mb-1'>Overtime List</label>
            <Box>
              <TextField
                className='w-100' color='secondary' variant="outlined"
                select
                value={selectOvertimeList}
                onChange={e => setSelectOvertimeList(e.target.value)}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (selected) => selected ? selected : "All",
                }}
                InputProps={{
                  sx: {
                    height: '48px',
                    fontSize: '14px'
                  }
                }}
              >
                <MenuItem value={""}>All</MenuItem>
                {overtimeList.map(type => (
                  <MenuItem value={type.Overtime_List}>{type.Overtime_List_Description} </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={2.5} className='d-grid'>
            <label className='mb-1'>Passes</label>
            <Box>
              <TextField
                className='w-100' color='secondary' variant="outlined"
                select
                value={selectPassess}
                onChange={e => setSelectPasses(e.target.value)}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (selected) => selected ? selected : "All",
                }}
                InputProps={{
                  sx: {
                    height: '48px',
                    fontSize: '14px'
                  }
                }}
              >
                <MenuItem value={""}>All</MenuItem>
                {passess.map(type => (
                  <MenuItem value={type.value}>{type.label} </MenuItem>
                ))}
              </TextField>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={3}>
            <label className='mb-1'>Employee</label>
            <Box>
              <Autocomplete
                options={employees || []}
                getOptionLabel={(option) => option.label}
                onChange={(event, newValue) => setSelectedEmp(newValue?.Emp_Code || "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Employee"
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "48px",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center"
                      }
                    }}
                  />
                )}
              />
            </Box>
          </Grid>

        </Grid>

        {loading ? 
            <Box className="w-100 h-100 d-flex justify-content-center align-items-center font-fam my-5" >
              <CircularProgress />
            </Box>
          :
          <>
            <div className='mt-4'>
              {rows?.length == 0 ? 
                <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565 }}>
                  <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                  <span className='mt-4' style={{ color: '#555555' }}>
                    No Passes
                  </span>
                </div>
                :
                <MyTable
                  rows={rows}
                  columns={columns}
                  checkboxSelection={false}
                  hideFooter={rows?.length > 100 ? false : true}
                  rowCount={rows?.length}
                  perPage={100}
                  // onRowSelectionModelChange={onRowSelectionModelChange}
                  // selectedRows={selectedEmployee}
                />
              }
            </div>
          </>
        }
      </Paper>

      <Modal show={addModal} size="md"
        onHide={() => { setAddModal(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>Add Passess</Modal.Title>
        </Modal.Header>

        <Modal.Body className='px-3'>
          <Row>
            <Col md={12}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Box sx={{ width: '100%' }}>
                  <DatePicker
                    className='w-100'
                    label={selectDate ? moment(selectDate).format('MM/DD/YYYY') : 'MM/DD/YYYY'}
                    value={selectDate}
                    onChange={(e) => setSelectDate(e)}
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: '48px',
                        fontSize: '14px'
                      },
                    }}
                    disablePast
                    dateInputIcon={<CalendarTodayIcon />}
                  />
                </Box>
              </LocalizationProvider>
            </Col>
          </Row>

          <Row  className='mt-3'>
            <Col md={12}>
              <TextField
                color='secondary' variant="outlined"
                select
                className='w-100'
                value={selectModalOvertime}
                onChange={e => setSelectModalOvertime(e.target.value)}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (selected) =>
                    selected ? selected : <span style={{ color: "#aaa" }}>Overtime List</span>,
                }}
                InputProps={{
                  sx: {
                    height: '48px',
                    fontSize: '14px'
                  }
                }}
              >
                {overtimeList.map(type => (
                  <MenuItem value={type.Overtime_List}>{type.Overtime_List_Description} </MenuItem>
                ))}
              </TextField>
            </Col>
          </Row>

          <Row className='mt-3'>
            <Col md={12}>
              <TextField
                color='secondary' variant="outlined"
                select
                className='w-100'
                value={selectModalPass}
                onChange={e => setSelectModalPass(e.target.value)}
                SelectProps={{
                  displayEmpty: true,
                  renderValue: (selected) =>
                    selected ? selected : <span style={{ color: "#aaa" }}>Passess</span>,
                }}
                InputProps={{
                  sx: {
                    height: '48px',
                    fontSize: '14px'
                  }
                }}
              >
                {passess.map(type => (
                  <MenuItem value={type.value}>{type.label} </MenuItem>
                ))}
              </TextField>
            </Col>
          </Row>

          <Row className='mt-3'>
            <Col md={12}>
              <Multiselect
                displayValue="label"
                options={employees}
                showCheckbox
                showArrow
                customCloseIcon={<img src="/images/cross.png" alt="close" />}
                placeholder="Employees"
                selectedValues={selectModalEmp}
                onSelect={(e) => setSelectModalEmp(e)}
                onRemove={(e) => setSelectModalEmp(e)}
                customInputRenderer={(inputProps) => (
                  <TextField
                    {...inputProps}
                    variant="outlined"
                    fullWidth
                    size="small"
                    style={{
                      "& .MuiInputBase-root": {
                        height: "auto",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                  />
                )}
              />
            </Col>
          </Row>
          
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-4' onClick={() => setAddModal(false)}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => handlePass()}>
                Submit
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={deleteModal} size="md"
        onHide={() => { setDeleteModal(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Passess</Modal.Title>
        </Modal.Header>

        <Modal.Body className='px-3'>
          <Row className='mx-1'>
              Are you sure you want to delete this pass ?
          </Row>
          
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-4' onClick={() => setDeleteModal(false)}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => handleDelete()}>
                Delete
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EditPasses;